export enum OnboardingEndpointsEnum {
  GET_FIRST_TIME_VISIT_STATUS = "FirstTimeVisit",
}
